import { SxProps, Theme } from '@mui/material'

export const drawerModalSx: SxProps<Theme> = {
  zIndex: 1_800,
}
